const isDevelopment = process.env.NODE_ENV === 'development'|| process.env.NEXT_PUBLIC_API_ENV === 'staging'
export const logger = {
  info: (...args: unknown[]) => {
    if (isDevelopment) {
      console.log('INFO:', ...args);
    }
  },
  warn: (...args: unknown[]) => {
    if (isDevelopment) {
      console.warn('WARN:', ...args);
    }
  },
  error: (...args: unknown[]) => {
    if (isDevelopment) {
      console.error('ERROR:', ...args);
    }
  },
  debug: (...args: unknown[]) => {
    if (isDevelopment) {
      console.debug('DEBUG:', ...args);
    }
  },
};
